export const isDev =
  process.env.NODE_ENV === "development" ||
  process.env.REACT_APP_VERCEL_ENV === "development" ||
  process.env.REACT_APP_VERCEL_ENV === "preview";

export const api = isDev
  ? "https://test.ecbase.nl/backoffice"
  : "https://app.ecbase.nl/backoffice";
